import { ReactElement } from "react";

export default function Image(props: any): ReactElement {
  const { children, url } = props;
  return (
    <img
      src={"/obrazky/" + url}
      style={{ maxHeight: "200px", width: "100%", objectFit: "contain", marginBottom: "10px" }}
    />
  );
}
